var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player-wrap",staticStyle:{"width":"100%","height":"100%"}},[_c('video',{ref:"videoRef",staticClass:"video-player",staticStyle:{"width":"100%","height":"100%","object-fit":"contain"},attrs:{"controls":"","autoplay":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }